import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Privacy and Sharing of Information',
    field: 'privacyAndSharingInformation',
    type: 'info',
    subLabel: `I authorize the clinic and its associated health professionals to collect my personal and medical information as documented above. In addition, I authorize the clinic and its associated health professionals to communicate with my family doctor and/or referring doctor as deemed necessary for my beneficial treatment. I also understand that my personal and medical information is confidential and will only be disclosed to third parties with my permission.`,
    answer: {
      type: 'consent-check',
      label: 'I agree.',
      name: 'privacyAndSharingConsent',
      required: true
    }
  }
];
export default questionsModels;
